import { render } from "./_form-phone2.vue?vue&type=template&id=f28a0db2"
import script from "./_form-phone2.vue?vue&type=script&lang=js"
export * from "./_form-phone2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__